import { t } from "@lingui/core/macro"
import { Sizes } from "../../../interfaces/sizing"
import { colorClass } from "../../../utils/css"
import { addPageAction } from "../../../utils/newrelic"
import { Typography } from "../../common"
import { ArrowCollapseLeft } from "../../common/atoms/Icons/Broadcast"
import { StylelessButton } from "../../common/atoms/StylelessButton"
import "./ReturnFromAwayUI.scss"
import { returnFromAway } from "../api"

export function ReturnFromAwayUI() {
    const handleReturnFromAway = () => {
        addPageAction("MobileBroadcastReturnFromAwayClicked")
        void returnFromAway()
    }

    return (
        <StylelessButton
            data-testid="return-away-ui-pill"
            className="ReturnFromAwayUI"
            id="ReturnFromAwayUIPill"
            onClick={handleReturnFromAway}
        >
            <ArrowCollapseLeft
                className="PillIcon"
                width="16px"
                height="16px"
            />
            <div className="PillTextContainer">
                <Typography
                    size={Sizes.smpx}
                    color={colorClass.whiteFontColor}
                    className="PillText"
                >
                    {t`You are Away and viewers can't see your broadcast.`}
                </Typography>
                <Typography
                    size={Sizes.smpx}
                    color={colorClass.whiteFontColor}
                    className="PillText"
                >
                    {t`Tap here to return from Away mode.`}
                </Typography>
            </div>
        </StylelessButton>
    )
}
